var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.25581C4.723 1.25581 1.25581 4.723 1.25581 9C1.25581 13.277 4.723 16.7442 9 16.7442C13.277 16.7442 16.7442 13.277 16.7442 9C16.7442 4.723 13.277 1.25581 9 1.25581ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0249 1.46384C5.0249 1.11706 5.30603 0.835938 5.65281 0.835938H6.49002C6.69191 0.835938 6.88149 0.933017 6.9995 1.09683C7.11751 1.26065 7.14955 1.47121 7.0856 1.66271C5.49614 6.42294 5.49614 11.5745 7.0856 16.3347C7.14955 16.5262 7.11751 16.7368 6.9995 16.9006C6.88149 17.0644 6.69191 17.1615 6.49002 17.1615H5.65281C5.30603 17.1615 5.0249 16.8804 5.0249 16.5336C5.0249 16.1929 5.29628 15.9156 5.63467 15.906C4.30537 11.3983 4.30537 6.5992 5.63467 2.09149C5.29628 2.08189 5.0249 1.80456 5.0249 1.46384Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.313 0.868432C11.6419 0.758601 11.9976 0.936216 12.1074 1.26515C13.7831 6.28353 13.7831 11.7143 12.1074 16.7327C11.9976 17.0616 11.6419 17.2392 11.313 17.1294C10.9841 17.0195 10.8065 16.6638 10.9163 16.3349C12.5057 11.5747 12.5057 6.42311 10.9163 1.66288C10.8065 1.33395 10.9841 0.978264 11.313 0.868432Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09781 11.0012C1.26162 10.8832 1.47219 10.8512 1.66369 10.9151C6.42392 12.5046 11.5755 12.5046 16.3357 10.9151C16.5272 10.8512 16.7378 10.8832 16.9016 11.0012C17.0654 11.1193 17.1625 11.3088 17.1625 11.5107V12.3479C17.1625 12.6947 16.8814 12.9758 16.5346 12.9758C16.1939 12.9758 15.9165 12.7045 15.9069 12.3661C11.3992 13.6954 6.60017 13.6954 2.09247 12.3661C2.08287 12.7045 1.80554 12.9758 1.46482 12.9758C1.11804 12.9758 0.836914 12.6947 0.836914 12.3479V11.5107C0.836914 11.3088 0.933993 11.1193 1.09781 11.0012Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3359 7.08463C11.5757 5.49517 6.42409 5.49517 1.66386 7.08463C1.33493 7.19446 0.97924 7.01684 0.869409 6.68791C0.759577 6.35898 0.937193 6.00329 1.26612 5.89346C6.2845 4.2178 11.7152 4.2178 16.7336 5.89346C17.0626 6.00329 17.2402 6.35898 17.1303 6.68791C17.0205 7.01684 16.6648 7.19446 16.3359 7.08463Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.2e599c46d38636040f09159f0a019dde.svg";
export { ForwardRef as ReactComponent };